// extracted by mini-css-extract-plugin
export default {"container":"PageLayout_container__-ee6C","title":"PageLayout_title__ZO783"};